var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.75,
    height: 30.474,
    viewBox: "0 0 26.75 30.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok_black",
    "data-name": "tiktok black",
    transform: "translate(155.173 176.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiktok_black-2",
    "data-name": "tiktok black",
    transform: "translate(-155.173 -176.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10076",
    "data-name": "Group 10076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27156",
    "data-name": "Path 27156",
    d: "M14.106,0c0,.275,0,.5,0,.722q0,9.9-.01,19.807c0,.312-.009.626-.039.937a4.512,4.512,0,0,1-8.969.1,4.425,4.425,0,0,1,3.4-4.872,12.2,12.2,0,0,1,2.476-.027v-5.1a28.129,28.129,0,0,0-3.143.21A9.4,9.4,0,0,0,.2,22.907a9.56,9.56,0,0,0,11.636,7.281,9.46,9.46,0,0,0,7.274-9.313c0-3.423-.022-6.846-.035-10.268,0-.184,0-.368,0-.658A12.65,12.65,0,0,0,26.75,12.54V7.616a7.78,7.78,0,0,1-5.382-2.244A7.737,7.737,0,0,1,19.06,0Z",
    transform: "translate(0)",
    fill: "#fcbf49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktok-black.a433a48a5ee1822edbd4513979ea5581.svg";
export { ForwardRef as ReactComponent };